import { toLower } from 'lodash'

export const getUniqueValsFromArrayOfObjs = (list: any, propName: any) => {
  const uniqueVals: Array<string> = []
  list.map((val: any) => {
    if (!uniqueVals.find(e => e === val[propName])) {
      uniqueVals.push(val[propName])
    }
    return uniqueVals
  })
  return uniqueVals
}

export const generateCountyOptions = (null)//counties: Array<County>, fieldName: string) => counties.map((county) => ({value: county[fieldName], label: county.county}) )

export const generateOptionsUsingName = (null)//dropdownArray: Array<DropdownType>, fieldName: string) => dropdownArray.filter(item => !!item.name).map((dropdownItem) => ({value: dropdownItem[fieldName], label: dropdownItem.name}) )


export const formatDate = (input: string | undefined): string  => {
  if (typeof input === 'number'){
    let inputStr = input+''
    return inputStr.substring(0,4)+'-'+inputStr.substring(4,6)+'-'+inputStr.substring(6,8)
  }
  else
    return ''
}

export const formatPhoneNumber = (phoneNumber: string | undefined): string => {
  var cleaned = ('' + phoneNumber).replace(/\D/g, '')
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    var intlCode = (match[1] ? '+1 ' : '')
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }
  return ''
}

export const formatPhoneNumberSaved = (phoneNumber: string | undefined): string => {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '')
  const phoneMatch = phoneNumber ? phoneNumber.trim().match(/^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/) : false
  if (phoneMatch) {
    return phoneNumber || ''
  }

  const digitsMatch = cleaned.match(/^(\d)+$/)
  if (digitsMatch) {
    const phoneNumberFixed = phoneNumber ? ( phoneNumber.length > 10 ? phoneNumber?.substring(0,10) : phoneNumber ) : ''
    return `(${phoneNumberFixed.substring(0,3)}) ${phoneNumberFixed.substring(3,6)}-${phoneNumberFixed.substring(6,10)}`
  }
  return ''
}

// FUNCTION convert date format
// PARAMS INPUT STRING = Tue Feb 27 2018 00:00:00 GMT-0600
// RETURNS 'YYYY-MM-DD' OR 2018-02-27
export const convert = (input: string | undefined) => {
  if (input !== undefined && input !== null) {
    var date = new Date(input),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2)
    return [date.getFullYear(), mnth, day].join('-')
  }
  return input
}

export const getFileName = (files: Array<File>) => {
  return files.length > 0 ? files[0].name : ''
}

export const getWeekDay = (option: number) => {
  switch (option) {
    case 0: 
      return 'monday'
    case 1: 
      return 'tuesday'
    case 2: 
      return 'wednesday'
    case 3: 
      return 'thursday'
    case 4: 
      return 'friday'
    case 5: 
      return 'saturday'
    case 6: 
      return 'sunday'
  }
}

export const getCertificationItemName = (itemName: string) => {
  switch (itemName) {
    case 'Background Check (BID)':
      return 'Owner/Operator Background Check (BID)'
    case 'Lease Agreement':
      return 'Mortgage or Lease Agreement'
    case 'Training Plan':
      return 'Training Plan Policy and Procedure'
    default:
      return itemName
  }
}

const certificationOrder = [
  'Certification Instruction Letter',
  'Certification Application',
  'Individual Questionnaire',
  'LCI Certified AFH Contract Addendum',
  'Proof of Insurance',
  'Mortgage or Lease Agreement',
  'HCBS Compliance Documentation',
  'Program Statement',
  'Succession Planning',
  'Health Attestation',
  'Health Assessment',
  'Owner/Operator Background Check (BID)',
  'Personal Reference Form',
  'Driver\'s License Attestation',
  'Government Issued Photo ID',
  'Furnace Inspection',
  'Fire Inspection',
  'Fire Extinguisher Invoice',
  'Fire Diagram',
  'Emergency Evacuation Plan',
  'Well Test',
  'Pet Vaccinations',
  'Prescription Medication Storage Policy',
  'Medication Administration Policy',
  'Training Plan Policy and Procedure',
  'Proof of Current Training',
  'Proof of Finances',
  'Site Visit',
]

const certificationAliases = {
  'Background Check (BID)': 'Owner/Operator Background Check (BID)',
  'Lease Agreement': 'Mortgage or Lease Agreement',
  'Training Plan': 'Training Plan Policy and Procedure',
}

export const sortCertificationItems = (items) => {
  if (!items) {
    return []
  }

  const rank = (type) => {
    const name = certificationAliases[type] || type
    const index = certificationOrder.indexOf(name)
    return index === -1 ? certificationOrder.length : index
  }

  return [...items].sort((a, b) => rank(a.certificationType) - rank(b.certificationType))
}

export const getUploadModalData = (itemType: string, data: any) => {
  switch (itemType) {
    case 'Copy of W-9': 
      return {
        providerApplicationItemId: data.w9Id,
        file: data.w9,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Copy of Facility Licensure':
      return {
        providerApplicationItemId: data.facilityLicenseId,
        file: data.facilityLicense,
        notApplicable: data.doesNotHaveFacilityLicense,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Copy of Certificate of Insurance': 
      return {
        providerApplicationItemId: data.certificateInsuranceId,
        file: data.certificateInsurance,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Debarment Attestation Letter': 
      return {
        providerApplicationItemId: data.debarmentAttestationLetterId,
        file: data.debarmentAttestationLetter,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Training Attestation Letter': 
      return {
        providerApplicationItemId: data.trainingAttestationLetterId,
        file: data.trainingAttestationLetter,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Civil Rights Compliance Attestation Letter':
      return {
        providerApplicationItemId: data.civilRightsComplianceAttestationLetterId,
        file: data.civilRightsComplianceAttestationLetter,
        notApplicable: data.doesNotApply,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Residential Worksheets':
      return {
        providerApplicationItemId: data.residentialWorksheetId,
        file: data.residentialWorksheet,
        notApplicable: data.residentialWorksheetDoesNotApply,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Certification Application': 
      return {
        providerApplicationCertificationId: data.certificationApplicationId,
        file: data.certificationApplication,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Individual Questionnaire': 
      return {
        providerApplicationCertificationId: data.individualQuestionnaireId,
        file: data.individualQuestionnaire,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Owner/Operator Background Check (BID)': 
      return {
        providerApplicationCertificationId: data.backgroundCheckId,
        file: data.backgroundCheck,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Proof of Insurance':
      return {
        providerApplicationCertificationId: data.proofOfInsuranceId,
        file: data.proofOfInsurance,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Personal Reference Form':
      return {
        providerApplicationCertificationId: data.referencesFormId,
        file: data.referencesForm,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'HCBS Compliance Documentation':
      return {
        providerApplicationCertificationId: data.hcbsComplianceDocumentationId,
        file: data.hcbsComplianceDocumentation,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Mortgage or Lease Agreement':
      return {
        providerApplicationCertificationId: data.leaseAgreementId,
        file: data.leaseAgreement,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Program Statement':
      return {
        providerApplicationCertificationId: data.programStatementId,
        file: data.programStatement,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Emergency Evacuation Plan':
      return {
        providerApplicationCertificationId: data.emergencyEvacuationPlanId,
        file: data.emergencyEvacuationPlan,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Succession Planning':
      return {
        providerApplicationCertificationId: data.successionPlanningId,
        file: data.successionPlanning,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Health Attestation':
      return {
        providerApplicationCertificationId: data.healthAttestationId,
        file: data.healthAttestation,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Health Assessment':
      return {
        providerApplicationCertificationId: data.healthAssessmentId,
        file: data.healthAssessmentNotApplicable ? [] : data.healthAssessment,
        notApplicable: data.healthAssessmentNotApplicable,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Driver\'s License Attestation':
      return {
        providerApplicationCertificationId: data.driversLicenseAttestationId,
        file: data.driversLicenseAttestation,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Furnace Inspection':
      return {
        providerApplicationCertificationId: data.furnaceInspectionId,
        file: data.furnaceInspection,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Fire Inspection':
      return {
        providerApplicationCertificationId: data.fireInspectionId,
        file: data.fireInspection,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Fire Extinguisher Invoice':
      return {
        providerApplicationCertificationId: data.fireExtinguisherInvoiceId,
        file: data.fireExtinguisherInvoice,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Well Test':
      return {
        providerApplicationCertificationId: data.wellTestId,
        file: data.wellTestNotApplicable ? [] : data.wellTest,
        notApplicable: data.wellTestNotApplicable,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Fire Diagram':
      return {
        providerApplicationCertificationId: data.fireDiagramId,
        file: data.fireDiagram,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Government Issued Photo ID':
      return {
        providerApplicationCertificationId: data.governmentIssuedPhotoIdId,
        file: data.governmentIssuedPhotoId,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Pet Vaccinations':
      return {
        providerApplicationCertificationId: data.petVaccinationsId,
        file: data.petVaccinationsNotApplicable ? [] : data.petVaccinations,
        notApplicable: data.petVaccinationsNotApplicable,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Prescription Medication Storage Policy':
      return {
        providerApplicationCertificationId: data.prescriptionMedicationStoragePolicyId,
        file: data.prescriptionMedicationStoragePolicy,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Medication Administration Policy':
      return {
        providerApplicationCertificationId: data.medicationAdministrationPolicyId,
        file: data.medicationAdministrationPolicy,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Training Plan Policy and Procedure':
      return {
        providerApplicationCertificationId: data.trainingPlanId,
        file: data.trainingPlan,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Proof of Current Training':
      return {
        providerApplicationCertificationId: data.proofOfCurrentTrainingId,
        file: data.proofOfCurrentTraining,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Proof of Finances':
      return {
        providerApplicationCertificationId: data.proofOfFinancesId,
        file: data.proofOfFinances,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Background Check Verification':
      return {
        providerApplicationItemId: data.backgroundCheckVerificationId,
        file: data.backgroundCheckVerification,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Additional Documents':
      return {
        providerApplicationItemId: data.additionalDocumentsId,
        file: data.additionalDocuments,
        notApplicable: data.additionalDocumentsDoesNotApply,
        type: itemType,
        removeFileList: data.removeFileList
      }
    default :
      return {}
  }
}

export const getLocationUploadModalData = (itemType: string, data: any) => {
  switch (itemType) {
    case 'Copy of Facility Licensure':
      return {
        locationApplicationItemId: data.locationFacilityLicenseId,
        file: data.facilityLicense,
        notApplicable: data.doesNotHaveFacilityLicense,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Copy of Certificate of Insurance': 
      return {
        locationApplicationItemId: data.certificateInsuranceId,
        file: data.certificateInsurance,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Debarment Attestation Letter': 
      return {
        locationApplicationItemId: data.debarmentAttestationLetterId,
        file: data.debarmentAttestationLetter,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Training Attestation Letter': 
      return {
        locationApplicationItemId: data.trainingAttestationLetterId,
        file: data.trainingAttestationLetter,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Civil Rights Compliance Attestation Letter':
      return {
        locationApplicationItemId: data.civilRightsComplianceAttestationLetterId,
        file: data.civilRightsComplianceAttestationLetter,
        notApplicable: data.doesNotApply,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Residential Worksheets':
      return {
        locationApplicationItemId: data.residentialWorksheetId,
        file: data.residentialWorksheet,
        notApplicable: data.residentialWorksheetDoesNotApply,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Certification Application': 
      return {
        locationApplicationCertificationId: data.certificationApplicationId,
        file: data.certificationApplication,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Owner/Operator Background Check (BID)': 
      return {
        locationApplicationCertificationId: data.backgroundCheckId,
        file: data.backgroundCheck,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Proof of Insurance':
      return {
        locationApplicationCertificationId: data.proofOfInsuranceId,
        file: data.proofOfInsurance,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'HCBS Compliance Documentation':
      return {
        locationApplicationCertificationId: data.hcbsComplianceDocumentationId,
        file: data.hcbsComplianceDocumentation,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Mortgage or Lease Agreement':
      return {
        locationApplicationCertificationId: data.leaseAgreementId,
        file: data.leaseAgreement,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Program Statement':
      return {
        locationApplicationCertificationId: data.programStatementId,
        file: data.programStatement,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Emergency Evacuation Plan':
      return {
        locationApplicationCertificationId: data.emergencyEvacuationPlanId,
        file: data.emergencyEvacuationPlan,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Succession Planning':
      return {
        locationApplicationCertificationId: data.successionPlanningId,
        file: data.successionPlanning,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Health Attestation':
      return {
        locationApplicationCertificationId: data.healthAttestationId,
        file: data.healthAttestation,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Health Assessment':
      return {
        locationApplicationCertificationId: data.healthAssessmentId,
        file: data.healthAssessmentNotApplicable ? [] : data.healthAssessment,
        notApplicable: data.healthAssessmentNotApplicable,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Driver\'s License Attestation':
      return {
        locationApplicationCertificationId: data.driversLicenseAttestationId,
        file: data.driversLicenseAttestation,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Furnace Inspection':
      return {
        locationApplicationCertificationId: data.furnaceInspectionId,
        file: data.furnaceInspection,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Fire Inspection':
      return {
        locationApplicationCertificationId: data.fireInspectionId,
        file: data.fireInspection,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Fire Extinguisher Invoice':
      return {
        locationApplicationCertificationId: data.fireExtinguisherInvoiceId,
        file: data.fireExtinguisherInvoice,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Well Test':
      return {
        locationApplicationCertificationId: data.wellTestId,
        file: data.wellTestNotApplicable ? [] : data.wellTest,
        notApplicable: data.wellTestNotApplicable,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Fire Diagram':
      return {
        locationApplicationCertificationId: data.fireDiagramId,
        file: data.fireDiagram,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Government Issued Photo ID':
      return {
        locationApplicationCertificationId: data.governmentIssuedPhotoIdId,
        file: data.governmentIssuedPhotoId,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Pet Vaccinations':
      return {
        locationApplicationCertificationId: data.petVaccinationsId,
        file: data.petVaccinationsNotApplicable ? [] : data.petVaccinations,
        notApplicable: data.petVaccinationsNotApplicable,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Prescription Medication Storage Policy':
      return {
        locationApplicationCertificationId: data.prescriptionMedicationStoragePolicyId,
        file: data.prescriptionMedicationStoragePolicy,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Medication Administration Policy':
      return {
        locationApplicationCertificationId: data.medicationAdministrationPolicyId,
        file: data.medicationAdministrationPolicy,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Training Plan Policy and Procedure':
      return {
        locationApplicationCertificationId: data.trainingPlanId,
        file: data.trainingPlan,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Proof of Current Training':
      return {
        locationApplicationCertificationId: data.proofOfCurrentTrainingId,
        file: data.proofOfCurrentTraining,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Background Check Verification':
      return {
        locationApplicationItemId: data.backgroundCheckVerificationId,
        file: data.backgroundCheckVerification,
        type: itemType,
        removeFileList: data.removeFileList
      }
    case 'Additional Documents':
      return {
        locationApplicationItemId: data.additionalDocumentsId,
        file: data.additionalDocuments,
        notApplicable: data.additionalDocumentsDoesNotApply,
        type: itemType,
        removeFileList: data.removeFileList
      }
    default :
      return {}
  }
}

export const getUploadType = (itemType: string) => {
  switch (itemType) {
    case 'Copy of W-9':
    case 'Copy of Facility Licensure':
    case 'Copy of Certificate of Insurance':
    case 'Debarment Attestation Letter':
    case 'Training Attestation Letter':
    case 'Civil Rights Compliance Attestation Letter':
    case 'Residential Worksheets':
    case 'Background Check Verification':
    case 'Additional Documents':
      return 'item'
    case 'Certification Application':
    case 'Individual Questionnaire':
    case 'Owner/Operator Background Check (BID)':
    case 'Proof of Insurance':
    case 'Personal Reference Form':
    case 'HCBS Compliance Documentation':
    case 'Mortgage or Lease Agreement':
    case 'Program Statement':
    case 'Emergency Evacuation Plan':
    case 'Succession Planning':
    case 'Health Attestation':
    case 'Health Assessment':
    case 'Driver\'s License Attestation':
    case 'Furnace Inspection':
    case 'Fire Inspection':
    case 'Fire Extinguisher Invoice':
    case 'Well Test':
    case 'Fire Diagram':
    case 'Government Issued Photo ID':
    case 'Pet Vaccinations':
    case 'Prescription Medication Storage Policy':
    case 'Medication Administration Policy':
    case 'Training Plan Policy and Procedure':
    case 'Proof of Current Training':
    case 'Proof of Finances':
      return 'certification'
    default :
      return ''
  }
}

export const getDateWithoutTZOffset = (date: Date) => new Date( new Date(date).getTime() - new Date(date).getTimezoneOffset() * -60000 )

export const getItemFromPath = (file: string, type: string) => {  // Change this in dev, qual and prod
  const filePath = file.split('\\')
  return filePath ? filePath[filePath.length - (type === 'file' ? 1 : 2)] : ''
}

export const getCardType = (progress: number, applicationStatus: string) => {
  if (progress < 100) {
    return 'in progress'
  }
  else {
    return toLower(applicationStatus)
  }
}

export const sortArrayOfObjects = (array: any, key: string) => {
  return array.sort((a, b) => {
    if (toLower(a[key] || '') > toLower(b[key] || '')) return 1
    if (toLower(a[key] || '') < toLower(b[key] || '')) return -1
    return 0
  })
}

export const getUploadFileAuditModalData = (itemType: string, data: any) => {
  switch (itemType) {
    case 'W-9 In Record': 
      return {
        providerFileAuditItemId: data.w9Id,
        itemType,
        file: data.w9,
      }
    case 'Active Certificate/Licensure':
      return {
        providerFileAuditItemId: data.activeCertificateLicensureId,
        itemType,
        file: data.activeCertificateLicensure,
      }
    case 'Active Liability Insurance':
      return {
        providerFileAuditItemId: data.activeLiabilityInsuranceId,
        itemType,
        file: data.activeLiabilityInsurance,
      }
    case 'Active Homeowners Insurance':
      return {
        providerFileAuditItemId: data.activeHomeownersInsuranceId,
        itemType,
        file: data.activeHomeownersInsurance,
      }
    case 'Active Auto Insurance':
      return {
        providerFileAuditItemId: data.activeAutoInsuranceId,
        itemType,
        file: data.activeAutoInsurance,
      }
  }
}